import {LoadPageDataParams, PageParamsToSendResolverInterface} from '@/src/core/domain/page'
import {PageParamsToSendRequest} from '@/src/core/domain/entities/page/page-params'
import castArray from 'lodash/castArray'
import {PageType} from '@/src/core/domain/entities/page'
import {inject, injectable} from 'inversify'
import {DI} from '@/src/config/di/types'

import type {IInstrumentationService} from '@/src/ports/services/monitoring/instrumentation'

@injectable()
export class PageParamsResolver implements PageParamsToSendResolverInterface {
  @inject(DI.IInstrumentationService)
  instrumentation!: IInstrumentationService

  async do(pageParams: LoadPageDataParams): Promise<PageParamsToSendRequest> {
    const parameters: PageParamsToSendRequest = {
      ...pageParams.params,
      ...pageParams.searchParams,
    }

    if (parameters && 'slug' in parameters && parameters.slug) {
      // TODO: OCP, придумать куда вынести похожие случаи
      if (pageParams.type == PageType.BrandProductList) {
        parameters.brand = decodeURIComponent(parameters.slug.toString())
      } else if (pageParams.type == PageType.Static) {
        parameters.path = `/${decodeURIComponent((castArray(parameters.slug) ?? []).join('/'))}`
      } else {
        parameters.path = `${decodeURIComponent((castArray(parameters.slug) ?? []).join('/'))}`
      }

      if (parameters.slug) {
        delete parameters.slug
      }
    }

    if (parameters?.page) {
      parameters.page = parseInt(parameters.page.toString())
    }
    if (parameters?.limit) {
      parameters.limit = parseInt(parameters.limit.toString())
    }

    return parameters
  }
}
